export interface CSVColumn {
  header: string;
  field: string;
  formatter?: (value: any, row: any) => string;
}

export function buildCSV(data: any[], columns: CSVColumn[]): string {
  const BOM = "\uFEFF";
  const header = columns.map((c) => `"${c.header}"`).join(",");

  const rows = data.map((row) =>
    columns
      .map((c) => {
        const raw = row[c.field];
        const val = c.formatter ? c.formatter(raw, row) : raw;
        const str = val == null ? "" : String(val);
        return `"${str.replace(/"/g, '""')}"`;
      })
      .join(","),
  );

  return BOM + [header, ...rows].join("\n");
}

export function downloadCSV(csvContent: string, fileName: string) {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
